import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amount',
})
export class amountPipe implements PipeTransform {
  transform(value: any): any {
    let result;
    if (value) {
      let date = Math.round((value + Number.EPSILON) * 100) / 100;
      let number = date.toFixed(2);
      result = `${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    } else {
      result = `0.00`;
    }
    return result;
  }
}
